import { Injectable } from "@angular/core";
import { NationalityDomainService } from "./nationality-domain.service";

@Injectable({
  providedIn: "root",
})
export class NationalityFacade {
  constructor(
    private readonly _nationalityDomainService: NationalityDomainService,
  ) {}

  getNationalities() {
    return this._nationalityDomainService.getNationalities();
  }
}
